import {styled} from 'styled-components';

export const StickySearchWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: var(--background-color, #fff);
  padding: 10px;
  margin: -10px;
`;
